import { useEffect } from 'react';
import { useAccount } from 'wagmi';

import useRaceStore from '@/stores/raceStore';
import Filters from '@/components/watch/Filters';
import WatchGrid from '@/components/watch/WatchGrid';

const Index = () => {
  const { userRaces, fetchUserRaces } = useRaceStore();
  const { address } = useAccount();

  useEffect(() => {
    if (address) {
      fetchUserRaces(address);
    }
  }, [address, fetchUserRaces]);

  if (userRaces.isLoading) {
    return (
      <div className="race-grid-loading">
        <div className="loading-spinner"></div>
        <p>Loading live races...</p>
      </div>
    );
  }

  if (userRaces.error) {
    return (
      <div className="race-grid-error">
        <p>{userRaces.error}</p>
        <button onClick={() => window.location.reload()} className="retry-button">
          Retry
        </button>
      </div>
    );
  }

  if (!userRaces || !userRaces.races || !userRaces.races.bets.length) {
    return (
      <div className="race-grid-empty">
        <p>No races found.</p>
      </div>
    );
  }

  // Show grid view
  return (
    <div className="watch-container">
      <Filters onFilter={(filters: any) => console.log(filters)} />
      <WatchGrid races={userRaces.races.bets} isLoading={userRaces.isLoading} error={userRaces.error} />
    </div>
  );
};

export default Index;
